export type DownloadAppBannerVariant = {
  type: DownloadAppBannerType;
  value?: string;
}

export enum DownloadAppBannerType {
  All = 'all',
  Mac = 'mac',
}